import { Container, Divider, Header, Segment } from "semantic-ui-react";
import "./Selvstaendige.css";
import AutoAccordion from "./common/AutoAccordion";

const OnlineSundhedshjaelp = (props) => (
  <div style={{ backgroundColor: "white" }}>
    <Header as="h1" textAlign="center">
      Få hurtig, professionel
      <br />
      sundhedshjælp
    </Header>

    <Divider hidden />

    <Container text>
      <Segment basic>
        <p className="manchet">
          Nogle gange kan man have en bekymring eller et problem, hvor det kan
          være rart at få professionel hjælp til at afklare, hvordan det skal
          tackles, forebygges og eventuelt behandles.
        </p>

        <p>
          Online Sundhedshjælp giver dig mulighed for at få en hurtig afklaring
          via videokonsultation – uanset om du er hjemme, på arbejde eller på
          ferie.
        </p>

        <p>
          Du har adgang til Online Sundhedshjælp, hvis du har en Letsikring af
          helbred eller en Lesikring af helbred med børn.{" "}
        </p>

        <h3>Læs mere og book tid</h3>
        <p>
          Online Sundhedshjælp omfatter 5 sundhedstilbud, som leveres af
          Hejdoktor og Prescriba.
        </p>

        <p>
          Du kan normalt få en tid indenfor 24 timer, og det kræver hverken
          lægehenvisning eller forudgående godkendelse fra PFA.
        </p>

        <AutoAccordion activeIndex={-1}>
          <AutoAccordion.Item title="Læs mere og book tid – Online Læge">
            <p>
              Online Læge er bemandet med praktiserende læger, som kan hjælpe
              dig med mange af de samme ting, som din egen læge kan. Det kan fx
              være:
            </p>
            <ul>
              <li>Lægefaglig rådgivning og behandling </li>
              <li>
                Svar på spørgsmål via mail, som besvares inden for 1 time i
                åbningstiden
              </li>
              <li>Udstedelse og fornyelse af recepter.</li>
            </ul>
            <p>
              Adgangen gælder også børn under 24 år samt eventuel
              ægtefælle/samlever, uanset om du har børnedækning på din
              Letsikring af helbred.{" "}
            </p>
            <p>
              Online Læge har åbent hverdage fra kl. 8.00-22.00 og i weekenden
              og på helligdage fra kl. 8.00-18.00.
            </p>
            <b>Sådan booker du en konsultation</b>
            <ol>
              <li>
                Download appen ”Hejdoktor” via App Store eller Google Play,
                eller gå til www.hejdoktor.dk.
              </li>
              <li>Log ind med MitID.</li>
              <li>
                Klik på ”Profil”, klik herefter på ”Min adgang”, og vælg
                herefter PFA som samarbejdspartner.
              </li>
              <li>Nu kan du booke en konsultation. </li>
            </ol>
            <p>
              Du skal invitere børn mellem 18 og 24 år samt ægtefælle/samlever,
              før de kan få adgang. Klik på ”Profil”. Klik herefter på ”Voksne i
              husstanden”, scroll til bunden af siden, og klik på ”Invitér
              familiemedlem”.
            </p>
          </AutoAccordion.Item>
          <AutoAccordion.Item title="Læs mere og book tid – Online Fysioterapeut">
            <p>
              Du kan få rådgivning og behandling af smerter i bevægeapparatet.
              Det kan fx være:
            </p>
            <ul>
              <li>Hold i ryggen</li>
              <li>Fibersprængning i låret</li>
              <li>Lændesmerter</li>
              <li>Tennisalbue.</li>
            </ul>
            <p>
              Adgangen gælder også dine børn under 24 år, hvis du har Letsikring
              af helbred med børn.{" "}
            </p>
            <p>
              Online Fysioterapeut har åbent hverdage fra kl. 8.00-21.00 og i
              weekenden og på helligdage fra kl. 8.00-18.00.{" "}
            </p>
            <p>Du kan ud fra en faglig vurdering få op til 6 konsultationer.</p>
            <b>Sådan booker du en konsultation</b>
            <ol>
              <li>
                Download appen ”Hejdoktor” via App Store eller Google Play,
                eller gå til www.hejdoktor.dk.
              </li>
              <li>Log ind med MitID.</li>
              <li>
                Klik på ”Profil”, klik herefter på ”Min adgang”, og vælg
                herefter PFA som samarbejdspartner.
              </li>
              <li>Nu kan du booke en konsultation.</li>
            </ol>
            <p>
              Du skal invitere børn mellem 18 og 24 år, før de kan få adgang.
              Klik på ”Profil”. Klik herefter på ”Voksne i husstanden”, scroll
              til bunden af siden, og klik på ”Invitér familiemedlem”.
            </p>
          </AutoAccordion.Item>
          <AutoAccordion.Item title="Læs mere og book tid – Online Psykolog">
            <p>
              Du har mulighed for at få rådgivning og behandling i forbindelse
              med fx:
            </p>
            <ul>
              <li>Eksamensangst</li>
              <li>Søvnproblemer</li>
              <li>Mistrivsel og stresssymptomer</li>
              <li>Tristhed og angstanfald.</li>
            </ul>
            <p>
              Adgangen gælder også dine børn mellem 12 og 24 år, hvis du har
              Letsikring af helbred med børn.{" "}
            </p>
            <p>
              Online Psykolog har åbent hverdage fra kl. 8.00-21.00 og lørdage
              fra kl. 9.00-14.00.{" "}
            </p>
            <p>Du kan ud fra en faglig vurdering få op til 6 konsultationer.</p>
            <b>Sådan booker du en konsultation</b>
            <ol>
              <li>Gå til Prescribas digitale platform Help.</li>
              <li>Log ind med MitID.</li>
              <li>
                Vælg ”Book tid” i menuen, og vælg herefter den hjælp, du ønsker.
              </li>
              <li>
                Herefter skal du blot følge flowet, herunder vælge om det er dig
                selv eller dit barn, du ønsker at booke tid til.
              </li>
            </ol>
          </AutoAccordion.Item>
          <AutoAccordion.Item title="Læs mere og book tid – Online Familierådgiver">
            <p>
              Som forælder kan du få råd og vejledning til at håndtere lettere
              udfordringer og bekymringer i forhold til dine børns trivsel og
              udvikling. Det kan fx være om:{" "}
            </p>
            <ul>
              <li>Trivsel i skolen</li>
              <li>Dit barns relationer</li>
              <li>Den digitale balance i hjemmet</li>
              <li>
                Hændelser i familien, fx ved alvorlig sygdom i den nærmeste
                familie eller skilsmisse.
              </li>
            </ul>
            <p>
              Online Familierådgiver har åbent hverdage fra kl. 8.00-21.00 og
              lørdage fra kl. 9.00-14.00.{" "}
            </p>
            <p>
              Du kan ud fra en faglig vurdering få op til 4 konsultationer, og
              du kan maksimalt få 1 forløb om året og maksimalt 6 i alt.
            </p>
            <p>
              Vær opmærksom på, at Online Familierådgiver ikke egner sig til
              udfordringer og bekymringer i forbindelse med børns psykiske
              diagnoser eller vold, misbrug og børneretssager. Her kan du ringe
              til os på 7080 5500 og høre, hvordan PFA kan hjælpe dig.
            </p>
            <p>
              For at deltage i familierådgivningen skal du som forælder have
              forældremyndigheden. Børn deltager ikke, men du er velkommen til
              at tage din partner med, hvis vedkommende også har
              forældremyndigheden. Hvis I er to, som deltager, logger I på
              sammen via din enhed.
            </p>
            <b>Sådan booker du en konsultation</b>
            <ol>
              <li>Gå til Prescribas digitale platform Help.</li>
              <li>Log ind med MitID.</li>
              <li>
                Vælg ”Book tid” i menuen, og vælg herefter den hjælp, du ønsker.
              </li>
              <li>Herefter skal du blot følge flowet.</li>
            </ol>
          </AutoAccordion.Item>
          <AutoAccordion.Item title="Læs mere og book tid – Online Coach">
            <p>
              Du kan få råd og vejledning i forhold til at håndtere udfordringer
              og ændringer i livet, før det udvikler sig til mistrivsel og
              stress. Det kan fx være:
            </p>
            <ul>
              <li>Uddannelse og første job</li>
              <li>Arbejde</li>
              <li>Karriere</li>
              <li>Skabe og bevare balancen i livet.</li>
            </ul>
            <p>
              Adgangen gælder også dine børn mellem 15 og 24 år, hvis du har
              Letsikring af helbred med børn.{" "}
            </p>
            <p>
              Online Coach har åbent hverdage fra kl. 8.00-21.00 og lørdage fra
              kl. 9.00-14.00.{" "}
            </p>
            <p>
              Du kan ud fra en faglig vurdering få op til 4 konsultationer, og
              du kan maksimalt få et forløb om året og maksimalt 6 forløb i hele
              den tid, du har din Letsikring af helbred.
            </p>
            <b>Sådan booker du en konsultation</b>
            <ol>
              <li>Gå til Prescribas digitale platform Help.</li>
              <li>Log ind med MitID.</li>
              <li>
                Vælg ”Book tid” i menuen, og vælg herefter den hjælp, du ønsker.
              </li>
              <li>
                Herefter skal du blot følge flowet, herunder vælge om det er dig
                selv eller dit barn, du ønsker at booke tid til.
              </li>
            </ol>
          </AutoAccordion.Item>
        </AutoAccordion>
        <Divider hidden />
        <Segment basic style={{ backgroundColor: "#f6f0e7", color: "black" }}>
          <p>
            Ønsker du at gøre brug af de øvrige dækninger i din Letsikring af
            helbred, skal du kontakte PFA.
          </p>
          <p>
            Se, hvordan på{" "}
            <a href="/forkunder/brugdinforsikring">Brug din forsikring.</a>
          </p>
        </Segment>
      </Segment>
    </Container>
  </div>
);

export default OnlineSundhedshjaelp;
